import React from 'react'
import styled from 'styled-components'
import { themeSizes } from '../styles/theme'

const SearchContext = React.createContext()

const ActionTypes = {
  OPEN_SEARCH: 'OPEN_SEARCH',
  CLOSE_SEARCH: 'CLOSE_SEARCH',
}

const searchReducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.OPEN_SEARCH: {
      return {
        ...state,
        isSearchOpen: true,
        // isDesktop: window.innerWidth >= themeSizes.widescreen,
        isDesktop:
          window.innerWidth >= themeSizes.navbarBreakpointTabletDesktop,
      }
    }
    case ActionTypes.CLOSE_SEARCH: {
      return {
        ...state,
        ...initialState,
      }
    }

    default:
      throw new Error(`Action is not supported: ${action.type}`)
  }
}

const initialState = {
  isSearchOpen: false,
  isDesktop: false,
}

const SearchWrapper = styled.div`
  max-height: 100vh;
  overflow: ${(props) => (props.$hideScrollbar ? 'hidden' : 'initial')};
`

export const SearchProvider = (props) => {
  const [state, dispatch] = React.useReducer(searchReducer, initialState)

  const value = React.useMemo(() => ({ state, dispatch }), [state])

  return (
    <SearchWrapper $hideScrollbar={state.isSearchOpen}>
      <SearchContext.Provider value={value} {...props} />
    </SearchWrapper>
  )
}

export const useSearchContext = () => {
  const context = React.useContext(SearchContext)

  if (!context) return {}

  const { state, dispatch } = context
  const { isSearchOpen, isDesktop } = state

  const openSearch = () => dispatch({ type: ActionTypes.OPEN_SEARCH })
  const closeSearch = () => dispatch({ type: ActionTypes.CLOSE_SEARCH })

  return { openSearch, closeSearch, isSearchOpen, isDesktop }
}
